module.exports = __webpack_public_path__ + "img/drugsafe-shield-icon-no-text.ae5ac537.png";